import { type getCurrentUserV1 } from "@/lib/data/requests";

export const mockedCurrentUser = (
  overrideDefaults?: Partial<
    Awaited<ReturnType<typeof getCurrentUserV1>>["data"]
  >,
) => {
  return {
    data: {
      ...overrideDefaults,

      // User attrs
      email: "testUser@testing.com",
      firstName: "Test",
      id: "",
      lastName: "User",
      permissionGroupIds: [],
      permissionGroups: [],
      effectiveGrants: [],
      label: "",
      firmId: "",
      enabled: true,
      owner: false,
      phoneNumber: "+15555550100",
      dateCreated: "",
      dateModified: "",
      firm: {
        id: "",
        name: "",
        dateCreated: "",
        dateModified: "",
      },
    },
    meta: {
      userMsg: "",
    },
  } as Awaited<ReturnType<typeof getCurrentUserV1>>;
};
